export const error = () => `Command not found
Try 'help' for more information
`;
